import $ from 'jquery';

if ('IntersectionObserver' in window) {

	$('.eb-js-observe').addClass('is-supported');

	const sliderModules = document.querySelectorAll('.eb-js-observe');
	const options = {
		threshold: 0.1
	};

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				entry.target.classList.add('is-visible');
				observer.unobserve(entry.target);
			} else {
				entry.target.classList.remove('is-visible');
			}
		});
	}, options);

	sliderModules.forEach((sliderModule, index) => {
		observer.observe(sliderModule);
	});

}
